/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ConversationSummaryOutStatus } from './conversationSummaryOutStatus';

export interface ConversationSummaryOut {
  status: ConversationSummaryOutStatus;
  body: string | null;
  template_id: string;
  failure_code?: string | null;
}
